var map = {
	"./Aakarsh Singh.jpeg": 3796,
	"./AkashPC.jpeg": 3067,
	"./Anjali_AgarwalPC.jpeg": 6074,
	"./Apoorva.jpeg": 3060,
	"./AradhyPC.jpeg": 3511,
	"./Arth kamboj.jpeg": 8418,
	"./Ayush AnjayPC.jpeg": 1136,
	"./HarshitPC.jpeg": 4386,
	"./KanakPC.jpeg": 1206,
	"./KartikeyPC.jpeg": 5220,
	"./KhushiGoelPC.jpeg": 4511,
	"./Lakshya Goel.jpeg": 284,
	"./NaitikPC.jpeg": 6285,
	"./NilenjaySengerPC.jpeg": 6835,
	"./SomilPC.jpeg": 9077
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7711;
module.exports = webpackAsyncContext;